export var ActionType;
(function (ActionType) {
    ActionType["AddAnswer"] = "AddAnswer";
    ActionType["AddExistingExternalInvoice"] = "AddExistingExternalInvoice";
    ActionType["AddNote"] = "AddNote";
    ActionType["AdvancedSearchExplicitExecute"] = "AdvancedSearchExplicitExecute";
    ActionType["AdvancedSearchImplicitExecute"] = "AdvancedSearchImplicitExecute";
    ActionType["BulkImport"] = "BulkImport";
    ActionType["BypassAcls"] = "BypassAcls";
    ActionType["ClientCommunitiesPdf"] = "ClientCommunitiesPdf";
    ActionType["ClientPdf"] = "ClientPdf";
    ActionType["CreateAudience"] = "CreateAudience";
    ActionType["CreateBulkMessage"] = "CreateBulkMessage";
    ActionType["CreateClient"] = "CreateClient";
    ActionType["CreateCommunity"] = "CreateCommunity";
    ActionType["CreateEmailTemplate"] = "CreateEmailTemplate";
    ActionType["CreateHostedForm"] = "CreateHostedForm";
    ActionType["CreateModifyInvoice"] = "CreateModifyInvoice";
    ActionType["CreateOrEditSignatureTemplate"] = "CreateOrEditSignatureTemplate";
    ActionType["CreateQuestion"] = "CreateQuestion";
    ActionType["CreateReference"] = "CreateReference";
    ActionType["CreateReferral"] = "CreateReferral";
    ActionType["CreateTask"] = "CreateTask";
    ActionType["CreateTenant"] = "CreateTenant";
    ActionType["CreateTour"] = "CreateTour";
    ActionType["CreateUser"] = "CreateUser";
    ActionType["CreateWorkflow"] = "CreateWorkflow";
    ActionType["DeleteAudience"] = "DeleteAudience";
    ActionType["DeleteBulkMessage"] = "DeleteBulkMessage";
    ActionType["DeleteEmailTemplate"] = "DeleteEmailTemplate";
    ActionType["DeleteHostedForm"] = "DeleteHostedForm";
    ActionType["DeleteNote"] = "DeleteNote";
    ActionType["DeleteQuestion"] = "DeleteQuestion";
    ActionType["DeleteReferral"] = "DeleteReferral";
    ActionType["DeleteSignatureTemplate"] = "DeleteSignatureTemplate";
    ActionType["DeleteTask"] = "DeleteTask";
    ActionType["DeleteTour"] = "DeleteTour";
    ActionType["DeleteWorkflow"] = "DeleteWorkflow";
    ActionType["EvergreenManageCommunityListings"] = "EvergreenManageCommunityListings";
    ActionType["EvergreenPublicRecordCreate"] = "EvergreenPublicRecordCreate";
    ActionType["EvergreenReadCommunityListings"] = "EvergreenReadCommunityListings";
    ActionType["EvergreenReadDataSources"] = "EvergreenReadDataSources";
    ActionType["EvergreenSchedulePropagate"] = "EvergreenSchedulePropagate";
    ActionType["EvergreenThumbnail"] = "EvergreenThumbnail";
    ActionType["ExportCsv"] = "ExportCsv";
    ActionType["FailedLogin"] = "FailedLogin";
    ActionType["Geocode"] = "Geocode";
    ActionType["IntegrationHipaaAcknowledgment"] = "IntegrationHipaaAcknowledgment";
    ActionType["InternalTrackEvergreenSignupRequest"] = "InternalTrackEvergreenSignupRequest";
    ActionType["InternalReportingLoadAllUsers"] = "InternalReportingLoadAllUsers";
    ActionType["InternalReportingModify"] = "InternalReportingModify";
    ActionType["InternalReportingShowActivity"] = "InternalReportingShowActivity";
    ActionType["InternalReportingViewTenant"] = "InternalReportingViewTenant";
    ActionType["ListAudiences"] = "ListAudiences";
    ActionType["ListBulkMessages"] = "ListBulkMessages";
    ActionType["LoadClients"] = "LoadClients";
    ActionType["LoadCollabClients"] = "LoadCollabClients";
    ActionType["LoadCommunities"] = "LoadCommunities";
    ActionType["LoadEmailTemplates"] = "LoadEmailTemplates";
    ActionType["LoadOwnClients"] = "LoadOwnClients";
    ActionType["LoadOwnSentMessages"] = "LoadOwnSentMessages";
    ActionType["LoadQuestions"] = "LoadQuestions";
    ActionType["LoadReferences"] = "LoadReferences";
    ActionType["LoadReferrals"] = "LoadReferrals";
    ActionType["LoadReferralsForEntity"] = "LoadReferralsForEntity";
    ActionType["LoadSentMessages"] = "LoadSentMessages";
    ActionType["LoadTasks"] = "LoadTasks";
    ActionType["LoadTenant"] = "LoadTenant";
    ActionType["LoadUsers"] = "LoadUsers";
    ActionType["ManageIntegrations"] = "ManageIntegrations";
    ActionType["MigrateFile"] = "MigrateFile";
    ActionType["ModifyAcls"] = "ModifyAcls";
    ActionType["ModifyEmailTemplate"] = "ModifyEmailTemplate";
    ActionType["ModifySharedEmailTemplate"] = "ModifySharedEmailTemplate";
    ActionType["ModifyTaskType"] = "ModifyTaskType";
    ActionType["MomsHouseReferral"] = "MomsHouseReferral";
    ActionType["MultiAccountSwitch"] = "MultiAccountSwitch";
    ActionType["Noop"] = "Noop";
    ActionType["ReadHostedForm"] = "ReadHostedForm";
    ActionType["ReadWorkflow"] = "ReadWorkflow";
    ActionType["ResetPassword"] = "ResetPassword";
    ActionType["SelfManageCreateUser"] = "SelfManageCreateUser";
    ActionType["SelfManageDisableUser"] = "SelfManageDisableUser";
    ActionType["SelfManageModifyUser"] = "SelfManageModifyUser";
    ActionType["SelfManageViewApiKey"] = "SelfManageViewApiKey";
    ActionType["SelfManageViewUser"] = "SelfManageViewUser";
    ActionType["SetPassword"] = "SetPassword";
    ActionType["SuccessfulLogin"] = "SuccessfulLogin";
    ActionType["SuperuserCloneUser"] = "SuperuserCloneUser";
    ActionType["SuperuserGenerateApiKey"] = "SuperuserGenerateApiKey";
    ActionType["SuperuserGeneric"] = "SuperuserGeneric";
    ActionType["SuperuserModifyCommunityMaster"] = "SuperuserModifyCommunityMaster";
    ActionType["SuperuserModifyTenant"] = "SuperuserModifyTenant";
    ActionType["SuperuserModifyUser"] = "SuperuserModifyUser";
    ActionType["SuperuserResetTenant"] = "SuperuserResetTenant";
    ActionType["UpdateAllSavedQueries"] = "UpdateAllSavedQueries";
    ActionType["UpdateAudience"] = "UpdateAudience";
    ActionType["UpdateBulkMessage"] = "UpdateBulkMessage";
    ActionType["UpdateClient"] = "UpdateClient";
    ActionType["UpdateClientAddCommunity"] = "UpdateClientAddCommunity";
    ActionType["UpdateClientAddContactPerson"] = "UpdateClientAddContactPerson";
    ActionType["UpdateClientDeleteContactPerson"] = "UpdateClientDeleteContactPerson";
    ActionType["UpdateClientRemoveCommunity"] = "UpdateClientRemoveCommunity";
    ActionType["UpdateClientUpdateContactPerson"] = "UpdateClientUpdateContactPerson";
    ActionType["UpdateCollabClient"] = "UpdateCollabClient";
    ActionType["UpdateCommunity"] = "UpdateCommunity";
    ActionType["UpdateCommunityAddContact"] = "UpdateCommunityAddContact";
    ActionType["UpdateCommunityRemoveContact"] = "UpdateCommunityRemoveContact";
    ActionType["UpdateCommunitySearch"] = "UpdateCommunitySearch";
    ActionType["UpdateCommunityUpdateContact"] = "UpdateCommunityUpdateContact";
    ActionType["UpdateCustomList"] = "UpdateCustomList";
    ActionType["UpdateFeatureTrack"] = "UpdateFeatureTrack";
    ActionType["UpdateEmailTemplate"] = "UpdateEmailTemplate";
    ActionType["UpdateLayout"] = "UpdateLayout";
    ActionType["UpdateNote"] = "UpdateNote";
    ActionType["UpdateOwnClient"] = "UpdateOwnClient";
    ActionType["UpdateQuestion"] = "UpdateQuestion";
    ActionType["UpdateReference"] = "UpdateReference";
    ActionType["UpdateReferral"] = "UpdateReferral";
    ActionType["UpdateRegionSettings"] = "UpdateRegionSettings";
    ActionType["UpdateTask"] = "UpdateTask";
    ActionType["UpdateTenant"] = "UpdateTenant";
    ActionType["UpdateTour"] = "UpdateTour";
    ActionType["UpdateUser"] = "UpdateUser";
    ActionType["ViewAllInvoices"] = "ViewAllInvoices";
    ActionType["ViewAudience"] = "ViewAudience";
    ActionType["ViewBulkMessage"] = "ViewBulkMessage";
    ActionType["ViewClient"] = "ViewClient";
    ActionType["ViewCollabClient"] = "ViewCollabClient";
    ActionType["ViewCommunity"] = "ViewCommunity";
    ActionType["ViewCommunityContract"] = "ViewCommunityContract";
    ActionType["ViewCustomList"] = "ViewCustomList";
    ActionType["ViewLayout"] = "ViewLayout";
    ActionType["ViewOwnClient"] = "ViewOwnClient";
    ActionType["ViewOwnInvoices"] = "ViewOwnInvoices";
    ActionType["ViewReference"] = "ViewReference";
    ActionType["ViewReports"] = "ViewReports";
    ActionType["ViewRestrictedWhiteLabelContent"] = "ViewRestrictedWhiteLabelContent";
    ActionType["ViewSignatureRequest"] = "ViewSignatureRequest";
    ActionType["ViewTask"] = "ViewTask";
    ActionType["ViewTenant"] = "ViewTenant";
    ActionType["ViewTour"] = "ViewTour";
})(ActionType || (ActionType = {}));
const actionTypeGroups = {
    contractDetails: {
        title: "Communities - Contract Details",
        description: "View contract details for a community",
        visible: true,
    },
    invoices: {
        title: "Invoices",
        description: "Create, view, and manage invoices",
        visible: true,
    },
    allClients: {
        title: "Clients - owned by others",
        description: "Manage all clients in the region",
        visible: true,
    },
    ownClients: {
        title: "Clients - owned by me",
        description: "Manage clients owned by me",
        visible: true,
    },
    clientCommunities: {
        title: "Clients - manage community options",
        description: "Manage client community options",
        visible: true,
    },
    clientContacts: {
        title: "Clients - manage contacts",
        description: "Manage client contacts",
        visible: true,
    },
    clientPdfs: {
        title: "Clients - PDFs",
        description: "Generate PDFs related to clients",
        visible: true,
    },
    communities: {
        title: "Communities",
        description: "Create, view, and manage communities",
        visible: true,
    },
    communityContacts: {
        title: "Communities - Contacts",
        description: "Manage community contacts",
        visible: true,
    },
    communitySearch: {
        title: "Communities - Search",
        description: "Manage community search results",
        visible: true,
    },
    references: {
        title: "Referral Sources",
        description: "Create, view, and manage referral sources",
        visible: true,
    },
    referrals: {
        title: "Referrals",
        description: "Create, view, and manage individual referrals (e.g. outbound referrals)",
        visible: true,
    },
    sentMessages: {
        title: "Sent Messages",
        description: "View sent messages",
        visible: true,
    },
    agencySettings: {
        title: "Agency Settings",
        description: "View and modify agency settings",
        visible: true,
    },
    emailTemplates: {
        title: "Email Templates",
        description: "View and modify email templates",
        visible: true,
    },
    reports: {
        title: "Reports",
        description: "View reports",
        visible: true,
    },
    customReports: {
        title: "Custom Reports",
        description: "Create and manage custom reports",
        visible: true,
    },
    csvExport: {
        title: "CSV Export",
        description: "Export data to CSV",
        visible: true,
    },
    signWise: {
        title: "Signwise",
        description: "Create and manage Signwise templates",
        visible: true,
    },
    notes: {
        title: "Notes",
        description: "Create and maange notes on clients, communities, and referral sources",
        visible: true,
    },
    tasks: {
        title: "Tasks",
        description: "Create and manage tasks on clients, communities, and referral sources",
        visible: true,
    },
    tours: {
        title: "Tours",
        description: "Create, view, and manage tours",
        visible: true,
    },
    workflows: {
        title: "Workflows",
        description: "Create and manage workflows",
        visible: true,
    },
    userManagement: {
        title: "User Management",
        description: "Manage users",
        visible: true,
    },
    hostedForm: {
        title: "Hosted Form",
        description: "Create and manage hosted forms",
        visible: true,
    },
    files: {
        title: "Files",
        description: "Manage file access",
        visible: true,
    },
    outreach: {
        title: "Outreach",
        description: "Manage outreach audiences and messages",
        visible: true,
    },
    customization: {
        title: "Customization",
        description: "Customize the application with questions and answers",
        visible: true,
    },
    integrations: {
        title: "Integrations",
        description: "Manage integrations with other systems",
        visible: true,
    },
    essentials: {
        title: "Essentials",
        description: "Essential actions all users need to function",
        visible: true,
    },
    uncategorized: {
        title: "Uncategorized",
        description: "These actions have no category and should be categorized",
        visible: true,
    },
    internal: {
        title: "Internal Use Only",
        description: "These actions are for internal use only - do not change",
        visible: false,
    },
    evergreen: {
        title: "Evergreen",
        description: "These actions are for evergreen use only - do not change",
        visible: false,
    },
    superuser: {
        title: "Superuser",
        description: "These actions are for superusers only",
        visible: false,
    },
};
const actionDetails = {
    [ActionType.LoadClients]: {
        actionType: ActionType.LoadClients,
        label: "List all clients",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewClient]: {
        actionType: ActionType.ViewClient,
        label: "View anyone's client",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateClient]: {
        actionType: ActionType.CreateClient,
        label: "Create client",
        groupKey: "ownClients",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateClient]: {
        actionType: ActionType.UpdateClient,
        label: "Update anyone's client",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateOwnClient]: {
        actionType: ActionType.UpdateOwnClient,
        label: "Update my client",
        groupKey: "ownClients",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateCollabClient]: {
        actionType: ActionType.UpdateCollabClient,
        label: "Update client where I collaborate",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.AddNote]: {
        actionType: ActionType.AddNote,
        label: "Add note",
        groupKey: "notes",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateNote]: {
        actionType: ActionType.UpdateNote,
        label: "Update note",
        groupKey: "notes",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteNote]: {
        actionType: ActionType.DeleteNote,
        label: "Delete note",
        groupKey: "notes",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.CreateTask]: {
        actionType: ActionType.CreateTask,
        label: "Create task",
        groupKey: "tasks",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateTask]: {
        actionType: ActionType.UpdateTask,
        label: "Update task",
        groupKey: "tasks",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.LoadCommunities]: {
        actionType: ActionType.LoadCommunities,
        label: "List all communities",
        groupKey: "communities",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewCommunityContract]: {
        actionType: ActionType.ViewCommunityContract,
        label: "View community contracts",
        groupKey: "contractDetails",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateCommunity]: {
        actionType: ActionType.CreateCommunity,
        label: "Create community",
        groupKey: "communities",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateCommunity]: {
        actionType: ActionType.UpdateCommunity,
        label: "Update community",
        groupKey: "communities",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.ViewCommunity]: {
        actionType: ActionType.ViewCommunity,
        label: "View single community",
        groupKey: "communities",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.UpdateClientRemoveCommunity]: {
        actionType: ActionType.UpdateClientRemoveCommunity,
        label: "Remove community option",
        groupKey: "clientCommunities",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateClientAddCommunity]: {
        actionType: ActionType.UpdateClientAddCommunity,
        label: "Add/Update community option",
        groupKey: "clientCommunities",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateClientAddContactPerson]: {
        actionType: ActionType.UpdateClientAddContactPerson,
        label: "Add client contact",
        groupKey: "clientContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateClientUpdateContactPerson]: {
        actionType: ActionType.UpdateClientUpdateContactPerson,
        label: "Update client contact",
        groupKey: "clientContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateClientDeleteContactPerson]: {
        actionType: ActionType.UpdateClientDeleteContactPerson,
        label: "Delete client contact",
        groupKey: "clientContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.SuccessfulLogin]: {
        actionType: ActionType.SuccessfulLogin,
        label: "Successful login",
        groupKey: "internal",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.MultiAccountSwitch]: {
        actionType: ActionType.MultiAccountSwitch,
        label: "Switch between accounts",
        groupKey: "internal",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.FailedLogin]: {
        actionType: ActionType.FailedLogin,
        label: "Failed login",
        groupKey: "internal",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.LoadTasks]: {
        actionType: ActionType.LoadTasks,
        label: "List tasks",
        groupKey: "tasks",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewTask]: {
        actionType: ActionType.ViewTask,
        label: "View single task",
        groupKey: "tasks",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewTenant]: {
        actionType: ActionType.ViewTenant,
        label: "View tenant information",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.CreateTenant]: {
        actionType: ActionType.CreateTenant,
        label: "Create tenant",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.CreateQuestion]: {
        actionType: ActionType.CreateQuestion,
        label: "Create question",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateQuestion]: {
        actionType: ActionType.UpdateQuestion,
        label: "Update question",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.AddAnswer]: {
        actionType: ActionType.AddAnswer,
        label: "Set answer value",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "update",
    },
    [ActionType.ViewReference]: {
        actionType: ActionType.ViewReference,
        label: "View referral contacts & organizations",
        groupKey: "references",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateReference]: {
        actionType: ActionType.CreateReference,
        label: "Create referral contacts & organizations",
        groupKey: "references",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateReference]: {
        actionType: ActionType.UpdateReference,
        label: "Update referral contacts & organizations",
        groupKey: "references",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.LoadReferences]: {
        actionType: ActionType.LoadReferences,
        label: "List referral contacts & organizations",
        groupKey: "references",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.UpdateTenant]: {
        actionType: ActionType.UpdateTenant,
        label: "Update agency settings",
        groupKey: "agencySettings",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.ClientCommunitiesPdf]: {
        actionType: ActionType.ClientCommunitiesPdf,
        label: "Download community comparison PDF",
        groupKey: "clientPdfs",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ClientPdf]: {
        actionType: ActionType.ClientPdf,
        label: "Download client intake PDF",
        groupKey: "clientPdfs",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.DeleteQuestion]: {
        actionType: ActionType.DeleteQuestion,
        label: "Delete Question",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.UpdateCommunityRemoveContact]: {
        actionType: ActionType.UpdateCommunityRemoveContact,
        label: "Remove community contact",
        groupKey: "communityContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.LoadEmailTemplates]: {
        actionType: ActionType.LoadEmailTemplates,
        label: "List email templates",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateEmailTemplate]: {
        actionType: ActionType.CreateEmailTemplate,
        label: "Create email template",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.DeleteEmailTemplate]: {
        actionType: ActionType.DeleteEmailTemplate,
        label: "Delete email template",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.UpdateEmailTemplate]: {
        actionType: ActionType.UpdateEmailTemplate,
        label: "Update email template",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.ViewOwnClient]: {
        actionType: ActionType.ViewOwnClient,
        label: "View my client",
        groupKey: "ownClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewCollabClient]: {
        actionType: ActionType.ViewCollabClient,
        label: "View client where I collaborate",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateUser]: {
        actionType: ActionType.CreateUser,
        label: "Create user",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.LoadUsers]: {
        actionType: ActionType.LoadUsers,
        label: "List users",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.LoadTenant]: {
        actionType: ActionType.LoadTenant,
        label: "Load tenant information",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.ModifySharedEmailTemplate]: {
        actionType: ActionType.ModifySharedEmailTemplate,
        label: "Update shared email template",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.ModifyEmailTemplate]: {
        actionType: ActionType.ModifyEmailTemplate,
        label: "Update email template",
        groupKey: "emailTemplates",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteTask]: {
        actionType: ActionType.DeleteTask,
        label: "Delete task",
        groupKey: "tasks",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ViewTour]: {
        actionType: ActionType.ViewTour,
        label: "View tour",
        groupKey: "tours",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateTour]: {
        actionType: ActionType.CreateTour,
        label: "Create tour",
        groupKey: "tours",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateTour]: {
        actionType: ActionType.UpdateTour,
        label: "Update tour",
        groupKey: "tours",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteTour]: {
        actionType: ActionType.DeleteTour,
        label: "Delete tour",
        groupKey: "tours",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ViewReports]: {
        actionType: ActionType.ViewReports,
        label: "View reports",
        groupKey: "reports",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.LoadQuestions]: {
        actionType: ActionType.LoadQuestions,
        label: "List questions",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.ResetPassword]: {
        actionType: ActionType.ResetPassword,
        label: "Reset password",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "update",
    },
    [ActionType.SetPassword]: {
        actionType: ActionType.SetPassword,
        label: "Set password",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "update",
    },
    [ActionType.Geocode]: {
        actionType: ActionType.Geocode,
        label: "Geocode",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.Noop]: {
        actionType: ActionType.Noop,
        label: "Noop",
        groupKey: "internal",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.UpdateUser]: {
        actionType: ActionType.UpdateUser,
        label: "Update my user",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.LoadOwnClients]: {
        actionType: ActionType.LoadOwnClients,
        label: "List my clients",
        groupKey: "ownClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.LoadCollabClients]: {
        actionType: ActionType.LoadCollabClients,
        label: "List clients where I collaborate",
        groupKey: "allClients",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ExportCsv]: {
        actionType: ActionType.ExportCsv,
        label: "Export CSV",
        groupKey: "csvExport",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.LoadReferrals]: {
        actionType: ActionType.LoadReferrals,
        label: "List referrals",
        groupKey: "referrals",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateReferral]: {
        actionType: ActionType.CreateReferral,
        label: "Create referral",
        groupKey: "referrals",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateReferral]: {
        actionType: ActionType.UpdateReferral,
        label: "Update referral",
        groupKey: "referrals",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteReferral]: {
        actionType: ActionType.DeleteReferral,
        label: "Delete referral",
        groupKey: "referrals",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.LoadSentMessages]: {
        actionType: ActionType.LoadSentMessages,
        label: "List anyone's sent messages",
        groupKey: "sentMessages",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.LoadOwnSentMessages]: {
        actionType: ActionType.LoadOwnSentMessages,
        label: "List my sent messages",
        groupKey: "sentMessages",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.LoadReferralsForEntity]: {
        actionType: ActionType.LoadReferralsForEntity,
        label: "List referrals for related record",
        groupKey: "referrals",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.InternalReportingLoadAllUsers]: {
        actionType: ActionType.InternalReportingLoadAllUsers,
        label: "Internal Reporting Load All Users",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.InternalReportingModify]: {
        actionType: ActionType.InternalReportingModify,
        label: "Internal Reporting Modify (mostly for billing details)",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "update",
    },
    [ActionType.SuperuserCloneUser]: {
        actionType: ActionType.SuperuserCloneUser,
        label: "Superuser - clone user",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.SuperuserModifyUser]: {
        actionType: ActionType.SuperuserModifyUser,
        label: "Superuser - modify user",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "update",
    },
    [ActionType.SuperuserGeneric]: {
        actionType: ActionType.SuperuserGeneric,
        label: "Superuser - generic",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.SuperuserGenerateApiKey]: {
        actionType: ActionType.SuperuserGenerateApiKey,
        label: "Superuser - generate API key",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.SuperuserModifyTenant]: {
        actionType: ActionType.SuperuserModifyTenant,
        label: "Superuser - modify tenant",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "update",
    },
    [ActionType.SuperuserModifyCommunityMaster]: {
        actionType: ActionType.SuperuserModifyCommunityMaster,
        label: "Superuser - modify community master",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "update",
    },
    [ActionType.SuperuserResetTenant]: {
        actionType: ActionType.SuperuserResetTenant,
        label: "Superuser - reset tenant",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "delete",
    },
    [ActionType.ViewAllInvoices]: {
        actionType: ActionType.ViewAllInvoices,
        label: "List all invoices",
        groupKey: "invoices",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ViewOwnInvoices]: {
        actionType: ActionType.ViewOwnInvoices,
        label: "View my invoices",
        groupKey: "invoices",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateModifyInvoice]: {
        actionType: ActionType.CreateModifyInvoice,
        label: "Create/update invoice",
        groupKey: "invoices",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.AddExistingExternalInvoice]: {
        actionType: ActionType.AddExistingExternalInvoice,
        label: "Add existing external invoice",
        groupKey: "invoices",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.EvergreenSchedulePropagate]: {
        actionType: ActionType.EvergreenSchedulePropagate,
        label: "Evergreen - schedule propagate",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.EvergreenReadDataSources]: {
        actionType: ActionType.EvergreenReadDataSources,
        label: "Evergreen - list data sources",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.EvergreenThumbnail]: {
        actionType: ActionType.EvergreenThumbnail,
        label: "Evergreen thumbnail",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.EvergreenPublicRecordCreate]: {
        actionType: ActionType.EvergreenPublicRecordCreate,
        label: "Evergreen - create public record",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.EvergreenManageCommunityListings]: {
        actionType: ActionType.EvergreenManageCommunityListings,
        label: "Evergreen - manage community listings",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.EvergreenReadCommunityListings]: {
        actionType: ActionType.EvergreenReadCommunityListings,
        label: "Evergreen - read community listings",
        groupKey: "evergreen",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.MomsHouseReferral]: {
        actionType: ActionType.MomsHouseReferral,
        label: "Moms House Referral",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.UpdateCommunitySearch]: {
        actionType: ActionType.UpdateCommunitySearch,
        label: "Show/hide community in search results",
        groupKey: "communitySearch",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.BulkImport]: {
        actionType: ActionType.BulkImport,
        label: "Bulk Import",
        groupKey: "superuser",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.UpdateCommunityAddContact]: {
        actionType: ActionType.UpdateCommunityAddContact,
        label: "Create community contact",
        groupKey: "communityContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateCommunityUpdateContact]: {
        actionType: ActionType.UpdateCommunityUpdateContact,
        label: "Update community contact",
        groupKey: "communityContacts",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.SelfManageViewUser]: {
        actionType: ActionType.SelfManageViewUser,
        label: "View user account",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.SelfManageCreateUser]: {
        actionType: ActionType.SelfManageCreateUser,
        label: "Create user account",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.SelfManageDisableUser]: {
        actionType: ActionType.SelfManageDisableUser,
        label: "Disable user account",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.SelfManageModifyUser]: {
        actionType: ActionType.SelfManageModifyUser,
        label: "Modify user account",
        groupKey: "userManagement",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.UpdateAllSavedQueries]: {
        actionType: ActionType.UpdateAllSavedQueries,
        label: "Update anyone's saved custom report",
        groupKey: "customReports",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.CreateOrEditSignatureTemplate]: {
        actionType: ActionType.CreateOrEditSignatureTemplate,
        label: "Create/update SignWise template",
        groupKey: "signWise",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.DeleteSignatureTemplate]: {
        actionType: ActionType.DeleteSignatureTemplate,
        label: "Delete SignWise template",
        groupKey: "signWise",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ViewSignatureRequest]: {
        actionType: ActionType.ViewSignatureRequest,
        label: "View signature request",
        groupKey: "signWise",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.CreateHostedForm]: {
        actionType: ActionType.CreateHostedForm,
        label: "Create hosted form",
        groupKey: "hostedForm",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.DeleteHostedForm]: {
        actionType: ActionType.DeleteHostedForm,
        label: "Delete hosted form",
        groupKey: "hostedForm",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ReadHostedForm]: {
        actionType: ActionType.ReadHostedForm,
        label: "View hosted form",
        groupKey: "hostedForm",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateWorkflow]: {
        actionType: ActionType.CreateWorkflow,
        label: "Create workflow",
        groupKey: "workflows",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.DeleteWorkflow]: {
        actionType: ActionType.DeleteWorkflow,
        label: "Delete workflow",
        groupKey: "workflows",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ReadWorkflow]: {
        actionType: ActionType.ReadWorkflow,
        label: "View workflow",
        groupKey: "workflows",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ModifyAcls]: {
        actionType: ActionType.ModifyAcls,
        label: "Modify file access",
        groupKey: "files",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.BypassAcls]: {
        actionType: ActionType.BypassAcls,
        label: "Ignore file access rules",
        groupKey: "files",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.InternalReportingShowActivity]: {
        actionType: ActionType.InternalReportingShowActivity,
        label: "Internal Reporting Show Activity",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.InternalReportingViewTenant]: {
        actionType: ActionType.InternalReportingViewTenant,
        label: "Internal Reporting View Tenant",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "read",
    },
    [ActionType.InternalTrackEvergreenSignupRequest]: {
        actionType: ActionType.InternalTrackEvergreenSignupRequest,
        label: "Internal - Track Evergreen Signup Request",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.CreateAudience]: {
        actionType: ActionType.CreateAudience,
        label: "Create audience",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateAudience]: {
        actionType: ActionType.UpdateAudience,
        label: "Update audience",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteAudience]: {
        actionType: ActionType.DeleteAudience,
        label: "Delete audience",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ViewAudience]: {
        actionType: ActionType.ViewAudience,
        label: "View audience",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ListAudiences]: {
        actionType: ActionType.ListAudiences,
        label: "List audiences",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.CreateBulkMessage]: {
        actionType: ActionType.CreateBulkMessage,
        label: "Create bulk message",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "create",
    },
    [ActionType.UpdateBulkMessage]: {
        actionType: ActionType.UpdateBulkMessage,
        label: "Update bulk message",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.DeleteBulkMessage]: {
        actionType: ActionType.DeleteBulkMessage,
        label: "Delete bulk message",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.ViewBulkMessage]: {
        actionType: ActionType.ViewBulkMessage,
        label: "View bulk message",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ListBulkMessages]: {
        actionType: ActionType.ListBulkMessages,
        label: "List bulk messages",
        groupKey: "outreach",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ModifyTaskType]: {
        actionType: ActionType.ModifyTaskType,
        label: "Modify task type",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.SelfManageViewApiKey]: {
        actionType: ActionType.SelfManageViewApiKey,
        label: "View API key",
        groupKey: "integrations",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.ManageIntegrations]: {
        actionType: ActionType.ManageIntegrations,
        label: "Manage integrations with 3rd parties",
        groupKey: "integrations",
        customRoleBehavior: "userDefined",
        permissionMode: "delete",
    },
    [ActionType.IntegrationHipaaAcknowledgment]: {
        actionType: ActionType.IntegrationHipaaAcknowledgment,
        label: "Acknowledge HIPAA risk for integration",
        groupKey: "integrations",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "create",
    },
    [ActionType.ViewLayout]: {
        actionType: ActionType.ViewLayout,
        label: "View layout",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.UpdateLayout]: {
        actionType: ActionType.UpdateLayout,
        label: "Update layout",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.ViewCustomList]: {
        actionType: ActionType.ViewCustomList,
        label: "View custom list",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.UpdateCustomList]: {
        actionType: ActionType.UpdateCustomList,
        label: "Update custom list",
        groupKey: "customization",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.MigrateFile]: {
        actionType: ActionType.MigrateFile,
        label: "Migrate file",
        groupKey: "internal",
        customRoleBehavior: "alwaysDisabled",
        permissionMode: "create",
    },
    [ActionType.ViewRestrictedWhiteLabelContent]: {
        actionType: ActionType.ViewRestrictedWhiteLabelContent,
        label: "View restricted white label content (documentation URL, product notifications, etc)",
        groupKey: "agencySettings",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.UpdateRegionSettings]: {
        actionType: ActionType.UpdateRegionSettings,
        label: "Update region settings",
        groupKey: "agencySettings",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
    [ActionType.AdvancedSearchExplicitExecute]: {
        actionType: ActionType.AdvancedSearchExplicitExecute,
        label: "Run a custom report",
        groupKey: "customReports",
        customRoleBehavior: "userDefined",
        permissionMode: "read",
    },
    [ActionType.AdvancedSearchImplicitExecute]: {
        actionType: ActionType.AdvancedSearchImplicitExecute,
        label: "Implicit advanced search",
        groupKey: "essentials",
        customRoleBehavior: "alwaysEnabled",
        permissionMode: "read",
    },
    [ActionType.UpdateFeatureTrack]: {
        actionType: ActionType.UpdateFeatureTrack,
        label: "Update feature track",
        groupKey: "agencySettings",
        customRoleBehavior: "userDefined",
        permissionMode: "update",
    },
};
export const getActionGroups = () => {
    const groups = new Map();
    for (const groupKey of Object.keys(actionTypeGroups)) {
        groups.set(groupKey, {
            ...actionTypeGroups[groupKey],
            key: groupKey,
            actions: [],
        });
    }
    for (const actionType of Object.values(ActionType)) {
        const detail = actionDetails[actionType];
        groups.get(detail.groupKey).actions.push(detail);
    }
    return Array.from(groups.values()).filter(g => g.actions.length > 0 && g.visible);
};
export const getActionTypes = (filterFn) => {
    return Object.values(ActionType).filter(a => filterFn(actionDetails[a]));
};
export const getActionPermissionMode = (actionType) => {
    return actionDetails[actionType].permissionMode;
};
//# sourceMappingURL=action-type.js.map